'use strict';
import noop from 'lodash/noop';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import React, {PureComponent} from 'react';
import * as T from 'prop-types';
import Measure from 'react-measure';
import ChatView from 'react-chatview';
import IonSpinner from '../../../_libs/reactionic/src/components/ionSpinner';


/**
 * This component wraps ChatView with Measure to trigger onInfiniteLoad any time the inner
 * scroll pane is too small to trigger loading by attempting to scroll the UI.
 * It can be used as a drop-in replacement anywhere ChatView is used.
 */
export class MeasuredChatView extends PureComponent {
  static MEASURE_WHITELIST = ['height'];

  // Be sure to keep in sync with ChatView props
  static propTypes = {
    flipped: T.bool,
    autoScroll: T.bool,
    scrollLoadThreshold: T.number,
    onInfiniteLoad: T.func.isRequired,
    usePropLoading: T.bool,
    isInfiniteLoading: T.bool,
    loadingSpinnerDelegate: T.node,
    className: T.string,

    // Only apply when using the load more button instead of infinite scrolling
    loadMoreClassName: T.string,
    loadMoreSpinner: IonSpinner.propTypes.icon,
    loadMoreButton: T.node,
    showLoadMoreButton: T.bool,
  };

  // Be sure to keep in sync with ChatView defaultProps
  static defaultProps = {
    flipped: false,
    autoScroll: true,
    scrollLoadThreshold: 10,
    usePropLoading: false,
    isInfiniteLoading: false,
    loadingSpinnerDelegate: <div />,
    className: '',
    loadMoreSpinner: 'spiral',
    showLoadMoreButton: false,
  };

  componentDidMount() {
    this.isInfiniteLoading$ = new Subject();
    this.viewHeight$ = new Subject();
    this.scrollHeight$ = new Subject();

    this.subscription = Observable.combineLatest(
      this.isInfiniteLoading$,
      this.viewHeight$,
      this.scrollHeight$,
      (isInfiniteLoading, viewDims, scrollDims) =>
        !isInfiniteLoading
        && scrollDims.height > 0
        && scrollDims.height < viewDims.height
    )
      .filter(it => !!it)
      .delay(0)
      .subscribe(() => this.props.onInfiniteLoad());
    this.handleViewHeightNext = this.viewHeight$.next.bind(this.viewHeight$);
    this.handleScrollHeightNext = this.scrollHeight$.next.bind(this.scrollHeight$);
    this.isInfiniteLoading$.next(this.props.isInfiniteLoading);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isInfiniteLoading !== nextProps.isInfiniteLoading) {
      this.isInfiniteLoading$.next(nextProps.isInfiniteLoading);
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe();
    this.isInfiniteLoading$ && this.isInfiniteLoading$.unsubscribe();
    this.viewHeight$ && this.viewHeight$.unsubscribe();
    this.scrollHeight$ && this.scrollHeight$.unsubscribe();
  }

  render() {
    return (
      <Measure
        whitelist={MeasuredChatView.MEASURE_WHITELIST}
        onMeasure={this.handleViewHeightNext}
      >
        <ChatView
          className={this.props.className}
          useSmoothScrollingWrapper={this.props.useSmoothScrollingWrapper}
          flipped={this.props.flipped}
          autoScroll={this.props.autoScroll}
          scrollLoadThreshold={this.props.scrollLoadThreshold}
          onInfiniteLoad={this.props.loadMoreButton ? noop : this.props.onInfiniteLoad}
          usePropLoading={this.props.usePropLoading}
          isInfiniteLoading={this.props.loadMoreButton ? false : this.props.isInfiniteLoading}
          loadingSpinnerDelegate={this.props.loadingSpinnerDelegate}
        >
          <Measure
            whitelist={MeasuredChatView.MEASURE_WHITELIST}
            onMeasure={this.handleScrollHeightNext}
          >
            {this.props.children}
          </Measure>
          {this.renderLoadMoreButton()}
        </ChatView>
      </Measure>
    );
  }

  renderLoadMoreButton() {
    if (!this.props.loadMoreButton || !this.props.showLoadMoreButton) {
      return null;
    } else if (this.props.isInfiniteLoading) {
      return (
        <IonSpinner icon="spiral" />
      );
    } else {
      return (
        <div
          className={this.props.loadMoreClassName}
          onClick={this.props.onInfiniteLoad}
        >
          {this.props.loadMoreButton}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lists/MeasuredChatView/index.js